import type { ReaderContent, ReaderGlossaryEntry } from '@/types/reader'

export type ReaderStudyCandidate = {
  entry: ReaderGlossaryEntry
  firstBlockIndex: number
  occurrences: number
  isSaved: boolean
  selected: boolean
}

export function getReaderStudyCandidates(
  content: ReaderContent,
  savedMap: Map<number, boolean> = new Map(),
  options: { limit?: number; preselectLimit?: number } = {}
): ReaderStudyCandidate[] {
  const limit = options.limit ?? 24
  const preselectLimit = options.preselectLimit ?? 8
  const seen = new Map<number, ReaderStudyCandidate>()

  content.blocks.forEach((block, blockIndex) => {
    block.tokens.forEach((token) => {
      if (!token.entryId) return
      const entry = content.glossary[String(token.entryId)]
      if (!entry) return

      const current = seen.get(entry.id)
      if (current) {
        current.occurrences += 1
        return
      }

      seen.set(entry.id, {
        entry,
        firstBlockIndex: blockIndex,
        occurrences: 1,
        isSaved: savedMap.get(entry.id) === true,
        selected: false
      })
    })
  })

  let selectedCount = 0
  return [...seen.values()]
    .sort(
      (a, b) =>
        a.firstBlockIndex - b.firstBlockIndex ||
        b.occurrences - a.occurrences ||
        a.entry.id - b.entry.id
    )
    .slice(0, limit)
    .map((candidate) => {
      const selected = !candidate.isSaved && selectedCount < preselectLimit
      if (selected) selectedCount += 1
      return { ...candidate, selected }
    })
}
